// @ts-nocheck
import { createInertiaApp } from '@inertiajs/svelte';
import { mount } from 'svelte';
import axios from 'axios';
import './bootstrap';
import '../css/app.css';

// Setup axios defaults (already done in bootstrap.js but ensuring it's loaded)
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Function to update CSRF token
function updateCsrfToken(token) {
    if (token) {
        // Update meta tag
        let metaTag = document.querySelector('meta[name="csrf-token"]');
        if (!metaTag) {
            metaTag = document.createElement('meta');
            metaTag.name = 'csrf-token';
            document.head.appendChild(metaTag);
        }
        metaTag.setAttribute('content', token);

        // Update axios default header
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    }
}

createInertiaApp({
    resolve: async name => {
        const pages = import.meta.glob('./Pages/**/*.svelte');
        return pages[`./Pages/${name}.svelte`]();
    },
    setup({ el, App, props }) {
        // Update CSRF token on initial page load
        if (props.initialPage?.props?.csrf_token) {
            updateCsrfToken(props.initialPage.props.csrf_token);
        }

        // Listen for Inertia page updates and update CSRF token
        document.addEventListener('inertia:success', (event) => {
            const page = event.detail.page;
            if (page?.props?.csrf_token) {
                updateCsrfToken(page.props.csrf_token);
            }
        });

        mount(App, { target: el, props });
    },
    progress: {
        color: '#29d',
    },
});

